/* ------------------------------------------------------------------
 * dt-uploader : le téléverseur maison des fiches produit.
 * Remplace UploadKit (go Mehdi 11/08/2026). Aucune dépendance.
 *
 * Contrat avec le tracker (dt-tracker.liquid) : le widget dispatche
 *   dt:upload-opened        le client engage le téléverseur
 *   dt:upload-file-chosen   {files: n} fichiers choisis
 *   dt:upload-done          UN dépôt a abouti (le détecteur de clic
 *                           refusé s'en sert pour nommer sa cause)
 *   dt:upload-error         {text, status} un envoi a échoué
 *   dt:upload-fallback      panne serveur, achat autorisé quand même
 *
 * Contrat avec la commande : chaque dépôt réussi pose un
 *   <input type="hidden" name="properties[Document N]" value="URL">
 * dans le formulaire d'achat principal, exactement là où UploadKit
 * posait les siens. La barre collante recopie ce formulaire (fix du
 * 05/08), donc les deux chemins d'achat portent les documents.
 *
 * Panne (décision Mehdi 11/08) : si le serveur ne répond pas, on ne
 * bloque JAMAIS la vente. Le widget passe en repli, laisse acheter,
 * et marque la commande « documents à envoyer par email ».
 * ------------------------------------------------------------------ */
(function () {
  "use strict";

  var CONCURRENCY = 2;          // envois de front : la montée mobile sature vite
  var TIMEOUT_MS = 1800000;     // 30 min : laisse finir les documents volumineux sur mobile
  var AUTO_RETRY_DELAY = 1500;  // un seul réessai automatique avant le diagnostic

  function t(root, key) {
    var el = root.querySelector('script[data-dt-i18n]');
    if (!el) return key;
    try {
      var val = JSON.parse(el.textContent)[key];
      if (!val) return key;
      /* Le filtre de traduction echappe l'apostrophe (d&#39;envois). Sans ce
         decodage, l'entite s'affichait telle quelle dans la ligne du fichier. */
      var box = document.createElement("textarea");
      box.innerHTML = val;
      return box.value || val;
    } catch (e) { return key; }
  }

  /* Un nom long mange la place du statut : on coupe au milieu en gardant le
     debut, la fin et l'extension (facture_traduction_acte.pdf -> factu…acte.pdf).
     Le nom entier reste en infobulle. */
  function shortName(n) {
    n = String(n || "");
    if (n.length <= 26) return n;
    var dot = n.lastIndexOf(".");
    var ext = dot > 0 ? n.slice(dot) : "";
    var base = dot > 0 ? n.slice(0, dot) : n;
    var keep = 26 - ext.length - 1;
    if (keep < 6) return n.slice(0, 25) + "…";
    var head = Math.ceil(keep * 0.6);
    return base.slice(0, head) + "…" + base.slice(base.length - (keep - head)) + ext;
  }

  function dispatch(name, detail) {
    try {
      document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
    } catch (e) { /* vieux navigateur : la mesure passe, jamais la vente */ }
  }

  function storageGet(key) {
    try { return localStorage.getItem(key) || ""; } catch (e) { return ""; }
  }

  function fmtSize(bytes) {
    if (bytes >= 1048576) return (bytes / 1048576).toFixed(1).replace(".0", "") + " Mo";
    return Math.max(1, Math.round(bytes / 1024)) + " Ko";
  }

  function init(root) {
    if (root.dataset.dtInit) return;
    root.dataset.dtInit = "1";

    var endpoint = (root.dataset.endpoint || "").replace(/\/$/, "");
    var required = root.dataset.required === "true";
    var maxFiles = parseInt(root.dataset.maxFiles, 10) || 30;
    var pagePath = root.dataset.page || location.pathname;

    // Mode « formulaire » (page devis, 11/08) : data-attach désigne le
    // formulaire cible et data-field-prefix nomme les champs (« Document N »
    // au lieu de properties[Document N]). Sans ces attributs, comportement
    // fiche produit inchangé : formulaire d'achat + propriétés de ligne.
    var attachSel = root.dataset.attach || "";
    var fieldPrefix = root.dataset.fieldPrefix || "";

    var input = root.querySelector('input[type="file"]');
    var drop = root.querySelector(".dt-uploader__drop");
    var list = root.querySelector(".dt-uploader__files");
    var msg = root.querySelector(".dt-uploader__msg");
    var fallbackNote = root.querySelector(".dt-uploader__fallback");

    var items = [];               // {id, file, name, size, status, pct, url, row, attempts}
    var seq = 0;
    var degraded = false;         // panne serveur constatée : achat autorisé
    var openedSent = false;

    // ---- le formulaire cible : celui du data-attach, sinon l'achat ----
    function mainForm() {
      if (attachSel) return document.querySelector(attachSel);
      var section = root.closest('[id^="shopify-section"]') || document;
      var forms = section.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        if (forms[i].querySelector('[name="add"]')) return forms[i];
      }
      return forms[0] || document.querySelector('form[action*="/cart/add"]');
    }

    // ---- propriétés de ligne : Document 1..N, renumérotées à chaque changement ----
    function syncProperties() {
      var form = mainForm();
      if (!form) return;
      var holder = form.querySelector("[data-dt-props]");
      if (!holder) {
        holder = document.createElement("span");
        holder.setAttribute("data-dt-props", "");
        holder.hidden = true;
        form.appendChild(holder);
      }
      holder.textContent = "";
      var n = 0;
      items.forEach(function (it) {
        if (it.status !== "done" || !it.url) return;
        n += 1;
        var inp = document.createElement("input");
        inp.type = "hidden";
        inp.name = fieldPrefix ? fieldPrefix + " " + n : "properties[Document " + n + "]";
        inp.value = it.url;
        holder.appendChild(inp);
      });
      if (degraded && !n) {
        var fb = document.createElement("input");
        fb.type = "hidden";
        fb.name = fieldPrefix ? "Documents" : "properties[Documents]";
        fb.value = t(root, "fallback_property");
        holder.appendChild(fb);
      }
    }

    // ---- messages ----
    var msgTimer = null;
    function say(key, sticky) {
      msg.textContent = t(root, key);
      msg.hidden = false;
      if (msgTimer) clearTimeout(msgTimer);
      if (!sticky) msgTimer = setTimeout(function () { msg.hidden = true; }, 6000);
    }

    // ---- repli panne ----
    function enterFallback() {
      if (degraded) return;
      degraded = true;
      root.classList.add("is-fallback");
      fallbackNote.hidden = false;
      items.forEach(function (it) {
        if (it.status === "uploading" || it.status === "error") setStatus(it, "fallback");
      });
      syncProperties();
      dispatch("dt:upload-fallback");
    }

    function probeHealth() {
      // Le serveur est-il vraiment injoignable, ou ce seul envoi a-t-il échoué ?
      var x = new XMLHttpRequest();
      x.open("GET", endpoint + "/api/uploads/health");
      x.timeout = 5000;
      x.onload = function () { /* le serveur vit : pas de repli, l'échec est local */ };
      x.onerror = x.ontimeout = function () { enterFallback(); };
      try { x.send(); } catch (e) { enterFallback(); }
    }

    // ---- rendu d'une ligne fichier ----
    function render(it) {
      if (!it.row) {
        it.row = document.createElement("li");
        it.row.className = "dt-uploader__file";
        it.row.innerHTML =
          '<span class="dt-uploader__fname"></span>' +
          '<span class="dt-uploader__fsize"></span>' +
          '<span class="dt-uploader__fstate" aria-live="polite"></span>' +
          '<button type="button" class="dt-uploader__retry" hidden></button>' +
          '<button type="button" class="dt-uploader__remove" aria-label=""></button>' +
          '<span class="dt-uploader__bar"><span class="dt-uploader__bar-fill"></span></span>';
        var nameEl = it.row.querySelector(".dt-uploader__fname");
        nameEl.textContent = shortName(it.name);
        nameEl.title = it.name;
        it.row.querySelector(".dt-uploader__fsize").textContent = fmtSize(it.size);
        var retryBtn = it.row.querySelector(".dt-uploader__retry");
        retryBtn.textContent = t(root, "retry");
        retryBtn.addEventListener("click", function () { it.attempts = 0; start(it); });
        var removeBtn = it.row.querySelector(".dt-uploader__remove");
        removeBtn.setAttribute("aria-label", t(root, "remove") + " " + it.name);
        removeBtn.innerHTML = "&#10005;";
        removeBtn.addEventListener("click", function () {
          if (it.xhr) { try { it.xhr.abort(); } catch (e) {} }
          items = items.filter(function (o) { return o !== it; });
          it.row.remove();
          syncProperties();
          pump();
        });
        list.appendChild(it.row);
      }
      var state = it.row.querySelector(".dt-uploader__fstate");
      var fill = it.row.querySelector(".dt-uploader__bar-fill");
      var retry = it.row.querySelector(".dt-uploader__retry");
      it.row.dataset.status = it.status;
      // « Reessayer » n'a de sens que si le prochain essai peut reussir : coupure
      // reseau, plafond par IP, serveur en difficulte. Sur un format refuse ou un
      // fichier trop gros, le meme envoi donnera toujours le meme refus, et le
      // bouton ne fait qu'inviter le client a insister. Le 31/08/2026 a 12h51 un
      // client espagnol a clique HUIT fois en 40 secondes sur un format refuse
      // avant de comprendre qu'il fallait changer de fichier. Il lui reste la
      // croix pour retirer la ligne et la zone de depot juste au-dessus.
      var refusDefinitif = it.errKey === "error_bad_type" || it.errKey === "error_too_large";
      retry.hidden = it.status !== "error" || refusDefinitif;
      if (it.status === "queued") { state.textContent = ""; fill.style.width = "0%"; }
      if (it.status === "uploading") {
        state.textContent = it.pct + " %";
        fill.style.width = it.pct + "%";
      }
      if (it.status === "done") { state.textContent = t(root, "status_done"); fill.style.width = "100%"; }
      if (it.status === "error") { state.textContent = t(root, it.errKey || "error_server"); }
      if (it.status === "fallback") { state.textContent = t(root, "status_fallback"); }
    }

    function setStatus(it, status) { it.status = status; render(it); }

    // ---- file d'envoi, 2 de front ----
    function pump() {
      if (degraded) return;
      var active = items.filter(function (o) { return o.status === "uploading"; }).length;
      items.forEach(function (it) {
        if (active >= CONCURRENCY) return;
        if (it.status === "queued") { active += 1; start(it); }
      });
    }

    function start(it) {
      it.pct = 0;
      setStatus(it, "uploading");
      var fd = new FormData();
      fd.append("visitor_id", storageGet("dt_vid"));
      fd.append("session_id", storageGet("dt_sid"));
      fd.append("page", pagePath);
      fd.append("file", it.file, it.name);
      var x = new XMLHttpRequest();
      it.xhr = x;
      x.open("POST", endpoint + "/api/uploads");
      x.timeout = TIMEOUT_MS;
      if (x.upload) x.upload.onprogress = function (e) {
        if (e.lengthComputable) {
          it.pct = Math.min(99, Math.round((e.loaded / e.total) * 100));
          render(it);
        }
      };
      x.onload = function () {
        it.xhr = null;
        var res = null;
        try { res = JSON.parse(x.responseText); } catch (e) {}
        if (x.status === 200 && res && res.ok && res.url) {
          it.url = res.url;
          setStatus(it, "done");
          syncProperties();
          dispatch("dt:upload-done");
          pump();
          return;
        }
        var key = "error_server";
        if (x.status === 413) key = "error_too_large";
        else if (x.status === 415) key = "error_bad_type";
        else if (x.status === 429) key = "error_rate";
        it.errKey = key;
        setStatus(it, "error");
        dispatch("dt:upload-error", { text: key, status: x.status, bytes: it.size, lisible: it.lisible });
        // 5xx : le serveur répond mais va mal ; on vérifie s'il faut le repli
        if (x.status >= 500) probeHealth();
        pump();
      };
      x.onerror = x.ontimeout = function () {
        it.xhr = null;
        it.attempts = (it.attempts || 0) + 1;
        if (it.attempts === 1) {
          // un seul réessai automatique : une coupure 4G d'une seconde ne
          // mérite ni un échec affiché ni un passage en repli
          setTimeout(function () { if (items.indexOf(it) !== -1 && !degraded) start(it); }, AUTO_RETRY_DELAY);
          return;
        }
        it.errKey = "error_network";
        setStatus(it, "error");
        dispatch("dt:upload-error", { text: "error_network", status: 0, bytes: it.size, lisible: it.lisible });
        // Repli au 2e échec, que notre serveur réponde ou non (décision de Mehdi,
        // 14/08/2026). Jusqu'ici probeHealth() concluait « le serveur vit, l'échec
        // est local » et laissait le client bloqué : le 14/08 à 16 h, un client
        // britannique a vu 4 fois « erreur réseau » pendant que nos dépôts passaient
        // à 15 h 54 et 16 h 02, puis il est parti sans commander. Vu du client il n'y
        // a aucune différence entre « leur serveur est en panne » et « je n'arrive
        // pas à les joindre » : dans les deux cas le document n'arrive pas et la
        // vente est bloquée. On récupère le document ensuite, comme dans le repli
        // de panne. Contrepartie assumée : quelques commandes à relancer.
        enterFallback();
        pump();
      };
      try { x.send(fd); } catch (e) {
        it.errKey = "error_network";
        setStatus(it, "error");
        probeHealth();
      }
    }

    // ---- sélection de fichiers ----
    // Le fichier est-il REELLEMENT lisible ? (01/09/2026)
    //
    // Sur Android, le selecteur ne rend pas le fichier mais une reference vers
    // l'application qui le detient (Photos, Drive, appareil photo). `size` arrive
    // avec la reference, donc un fichier annonce a 329 Ko peut etre introuvable au
    // moment de l'envoi : le POST est abandonne avant de partir, et vu du widget
    // c'est indistinguable d'une coupure reseau. UN SEUL OCTET LU tranche, et il se
    // lit en quelques millisecondes.
    //
    // Volontairement NON BLOQUANT : on n'attend pas ce resultat pour envoyer, sinon
    // on ralentirait les 99 % de depots qui vont bien. Il est joint a l'echec, qui
    // arrive deux secondes plus tard, largement de quoi avoir la reponse.
    function verifieLisible(it) {
      it.lisible = null;   // null = pas encore su, et c'est une reponse honnete
      // ⚠️ LE DERNIER OCTET, PAS LE PREMIER, et c'est tout le sujet. Le 01/09 a
      // 16h22 un client a echoue avec un fichier de 692 Ko declare LISIBLE par la
      // premiere version de ce test, puis a reussi avec 95 Ko trente secondes plus
      // tard. Le debut d'un fichier est presque toujours disponible : c'est la
      // vignette, la version allegee que Google Photos garde en local quand il a
      // « libere de l'espace ». La FIN, elle, n'est la que si le fichier entier est
      // vraiment sur le telephone. D'ou le test des deux bouts, pour le meme prix.
      var taille = it.file.size || 0;
      var bouts = [it.file.slice(0, 1)];
      if (taille > 1) bouts.push(it.file.slice(taille - 1, taille));
      var restants = bouts.length;
      var lit = function (bout) {
        var ok = function () { restants -= 1; if (!restants && it.lisible !== false) it.lisible = true; };
        var ko = function () { it.lisible = false; };
        try {
          if (bout.arrayBuffer) { bout.arrayBuffer().then(ok, ko); return; }
          var fr = new FileReader();
          fr.onload = ok;
          fr.onerror = ko;
          fr.readAsArrayBuffer(bout);
        } catch (e) { ko(); }
      };
      try { bouts.forEach(lit); } catch (e) { it.lisible = false; }
    }

    function addFiles(fileList) {
      var files = Array.prototype.slice.call(fileList || []);
      if (!files.length) return;
      // La TAILLE de ce qui est choisi, pas seulement le nombre (01/09/2026).
      // Les echecs « reseau » de clients sont tous des Android, tous avec la meme
      // sequence : le navigateur passe en arriere-plan pendant le selecteur de
      // fichiers, revient, le fichier est choisi, et l'envoi echoue en deux secondes
      // SANS QUE LE POST ATTEIGNE JAMAIS LE SERVEUR (verifie dans les logs nginx le
      // 01/09 : le preflight OPTIONS passe, le POST n'arrive pas).
      //
      // ⚠️ `size` NE SUFFIT PAS a le voir, et c'est la lecon du 01/09 : c'est une
      // etiquette donnee par l'application qui detient le fichier. La cliente de
      // 15h54 annoncait 329 Ko pour un fichier qui n'est jamais parti. La taille se
      // garde (elle situe l'envoi) mais elle ne prouve rien : voir verifieLisible.
      var octetsChoisis = 0, illisibles = 0;
      files.forEach(function (f) {
        octetsChoisis += f.size || 0;
        if (!f.size) illisibles += 1;
      });
      dispatch("dt:upload-file-chosen", { files: files.length, bytes: octetsChoisis, illisibles: illisibles });
      var refused = 0;
      files.forEach(function (f) {
        if (items.length >= maxFiles) { refused += 1; return; }
        var dup = items.some(function (o) { return o.name === f.name && o.size === f.size; });
        if (dup) return;
        var it = { id: ++seq, file: f, name: f.name, size: f.size, status: "queued", pct: 0, attempts: 0 };
        verifieLisible(it);
        items.push(it);
        render(it);
      });
      if (refused) say("error_max_files");
      pump();
    }

    function markOpened() {
      if (openedSent) return;
      openedSent = true;
      dispatch("dt:upload-opened");
      setTimeout(function () { openedSent = false; }, 4000);
    }

    drop.addEventListener("click", function () { markOpened(); input.click(); });
    drop.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); markOpened(); input.click(); }
    });
    input.addEventListener("change", function () {
      addFiles(input.files);
      input.value = "";        // re-choisir le même fichier doit re-déclencher change
    });
    ["dragover", "dragenter"].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add("is-drag"); });
    });
    ["dragleave", "drop"].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove("is-drag"); });
    });
    drop.addEventListener("drop", function (e) {
      markOpened();
      if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files);
    });

    // ---- garde-fou d'achat : rien au panier sans document déposé ----
    // Document en phase CAPTURE : on passe avant les gestionnaires du thème
    // (actionAddToCart2) et après le tracker, qui écoute aussi en capture et
    // s'est enregistré avant nous ; le clic refusé reste donc bien mesuré.
    function canPurchase() {
      // Un envoi EN COURS bloque toujours, même quand le dépôt est facultatif
      // (page devis) : partir sans les liens ferait une demande sans documents.
      var moving = items.some(function (o) { return o.status === "uploading" || o.status === "queued"; });
      if (moving && !degraded) return "wait";
      if (!required || degraded) return "ok";
      return items.some(function (o) { return o.status === "done"; }) ? "ok" : "need";
    }
    document.addEventListener("click", function (e) {
      if (attachSel) return;   // mode formulaire : le garde-fou vit sur submit
      var btn = e.target && e.target.closest && e.target.closest('[name="add"]');
      if (!btn) return;
      var form = mainForm();
      if (!form || !form.contains(btn)) return;      // un autre produit (popup, etc.)
      var verdict = canPurchase();
      if (verdict === "ok") return;
      e.preventDefault();
      e.stopPropagation();
      say(verdict === "wait" ? "wait_uploads" : "need_docs", verdict === "need");
      root.scrollIntoView({ behavior: "smooth", block: "center" });
      root.classList.add("is-attention");
      setTimeout(function () { root.classList.remove("is-attention"); }, 1200);
    }, true);
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (form !== mainForm()) return;
      var verdict = canPurchase();
      if (verdict === "ok") return;
      e.preventDefault();
      e.stopPropagation();
      say(verdict === "wait" ? "wait_uploads" : "need_docs", verdict === "need");
      root.scrollIntoView({ behavior: "smooth", block: "center" });
    }, true);
  }

  function boot() {
    var roots = document.querySelectorAll(".dt-uploader");
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);   // éditeur de thème
})();
